import * as React from "react";

import { All } from "./All";
import { ReferralDetail } from "./ReferralDetail";
import { PpqDetail } from "./PpqDetail";
import { PhysiotherapyReferralDetail } from "./PhysiotherapyReferralDetail";
import { FastTrackPitPupMedicalFormDetail } from "./FastTrackPitPupMedicalFormDetail";
import { SraDetail } from "./SraDetail";
import { GenericCaseFormDetail } from "./GenericCaseFormDetail";

import { Fragment } from "redux-little-router";

export const Base: React.FunctionComponent = () => {
    return (
        <div className="partially-matched-referrals">
            <Fragment forRoute="/referral/:customerId/:referralId">
                <div>
                    <ReferralDetail />
                </div>
            </Fragment>
            <Fragment forRoute="/physiotherapyReferral/:customerId/:referralId">
                <div>
                    <PhysiotherapyReferralDetail />
                </div>
            </Fragment>
            <Fragment forRoute="/ppq/:customerId/:referralId">
                <div>
                    <PpqDetail />
                </div>
            </Fragment>
            <Fragment forRoute="/genericCaseForm/:customerId/:referralId">
                <div>
                    <GenericCaseFormDetail />
                </div>
            </Fragment>
            <Fragment forRoute="/fasttrackpitpupmedicalform/:customerId/:fastTrackPitPupMedicalFormId">
                <div>
                    <FastTrackPitPupMedicalFormDetail />
                </div>
            </Fragment>
            <Fragment forRoute="/stressriskassessment/:customerId/:sraId">
                <div>
                    <SraDetail />
                </div>
            </Fragment>
            <Fragment forRoute="/">
                <div>
                    <All />
                </div>
            </Fragment>
        </div>
    );
};
